import { FieldHandler, BoardColumnConfig } from '../types';
import { convertConfigToSheetjs } from '../utils';
import _ from 'lodash';

export type Config = BoardColumnConfig;

export const handler: FieldHandler<Config> = {
  defaultConfig: {},

  type: 'formula',

  extractFieldsFromBoard: (board) => {
    return board.columns.flatMap((column) => {
      if (column.type === 'formula') {
        return [
          {
            id: column.id,
            label: column.title,
          },
        ];
      }

      return [];
    });
  },

  exportTo: (outputFormat, fieldId, boardItem, board, config, fieldGroup) => {
    const columnValue = boardItem.values.find(({ column_id }) => fieldId === column_id);

    if (!columnValue || columnValue.column_type !== 'formula' || columnValue.value_type === 'error') {
      return null;
    }

    if (outputFormat === 'sheetjs') {
      if (fieldGroup.formula_resolution === 'from_api') {
        const text = columnValue.value.text;
        return {
          ...convertConfigToSheetjs(config),
          v: text !== null ? text : undefined,
          t: 's',
        };
      } else {
        const value = columnValue.value.value;
        return {
          ...convertConfigToSheetjs(config),
          v: value !== null ? value : undefined,
          t: _.isNumber(value) ? 'n' : 's',
        };
      }
    }
  },
};

export default handler;
